import { FormFieldTypes } from "../../../../../components/forms/libs/data/formFieldType";
import { validationTypes } from "../../../../../components/forms/libs/data/ValidationTypes";

export const HideShowNotificationPeriodFieldsConfig = [
    {
        id: "notificationPeriod",
        label: "Notification Period(days)",
        Field_Name: "Notification Period(days)",
        fieldType: FormFieldTypes.INPUT,
        dataField: "notificationPeriod",
        fieldSetting: {
            placeholder: "Please Enter Name",
            allowSpace: true,
            textareaRows: 4,
        },
        validation: [{ type: validationTypes.REQUIRE }],
        style: {
            containerCss: "col-lg-6 col-md-6 validation-left-0 mb-2",
        },
    },
]
